export default "__VITE_ASSET__fe599018__"